import type { IxcMutualfundsV1MutualFundsJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const MUTUAL_FUNDS_JOB_BASE_PATH = getResolvedPath('/clearing/operations/mutualfunds/job');

export const getMutualFundsJobPath: EntityPathBuilder<IxcMutualfundsV1MutualFundsJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return MUTUAL_FUNDS_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.mutualFundsJobId) {
        return undefined;
      }

      return getResolvedPath(`${MUTUAL_FUNDS_JOB_BASE_PATH}/$jobId`, { jobId: context.keys.mutualFundsJobId, ...context.keys });
    }
  }
};

export function getMutualFundsJobDetailPath(mutualFundsJobId: string | undefined) {
  if (!mutualFundsJobId) {
    return undefined;
  }

  return getMutualFundsJobPath({ kind: 'detail', keys: { mutualFundsJobId } });
}
